<template>
    <el-upload :headers="{'fitness-appId':'2001'}" with-credentials class="avatar-uploader" :action="action" :show-file-list="false" :on-success="handleAvatarSuccess">
        <img v-if="value" :src="value" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
</template>
<script>
import * as Constants from '@/config/constants'
export default {
  data () {
    return {
        // action:"https://jsonplaceholder.typicode.com/posts/"
      action: Constants.SERVER_HOST + '/upload/'
    }
  },
  methods: {
    handleAvatarSuccess (res, file) {
      // this.$emit('input', URL.createObjectURL(file.raw))
      this.$emit('input', res.name)
    }
  },
  props: {
    value: { required: true }
  }
}
</script>
<style scoped>
.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// ImageUpload.vue?5fe3d6d4